import React from "react";
import "../Css/Contact.css";
import "../Css/Simpleform.css";

import { useFormik } from "formik";
function Simpleform() {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      channel: "",
    },
    onSubmit: async (values) => {
      // preventDefault()
      const response = await fetch("http://localhost:8080/", {
        method: "POST",
        body: JSON.stringify(values),
        headers: {
          "content-Type": "application/Json",
        },
      });
      await response.json();
      // console.log(res);
      alert("form has been submitted send other details your email address");
    },
    validate: (values) => {
      let errors = {};

      if (!values.username) {
        errors.username = "This field is Required";
      }
      if (!values.useremail) {
        errors.useremail = "Required";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.useremail)
      ) {
        errors.useremail = "Invalid email address";
      }

      if (!values.usertext) {
        errors.usertext = "This field is Required";
      }

      return errors;
    },
  });

  return (
    <div>
      <form onSubmit={formik.handleSubmit}>
        <div className="container-fluid">
          <div className="container">
            <div className="row" id="formrow">
              <input
                id="name"
                type="text"
                value={formik.values.username}
                placeholder="Enter-your-name "
                name="username"
                maxLength={20}
                minLength={3}
             
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.touched.username && formik.errors.username ? (
                <div id="error">{formik.errors.username}</div>
              ) : null}
            
            <div>
              <input
                id="email"
                type="email"
                placeholder="example@gmail.com"
                name="useremail"
                value={formik.values.useremail}
                
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              />
              {formik.touched.useremail && formik.errors.useremail ? (
                <div id="error">{formik.errors.useremail}</div>
              ) : null}
            </div>

            <div>
              <textarea
                name="usertext"
                id="textarea"
                cols="64"
                rows="4"
                type="text"
                placeholder="Enter your message"
                minLength={50}
                maxLength={1000}
                value={formik.values.usertext}
                onBlur={formik.handleBlur}
                onChange={formik.handleChange}
              ></textarea>
              {formik.errors.usertext ? (
                <div id="error">
                  {formik.touched.useremail && formik.errors.usertext}
                </div>
              ) : null}
            </div>

            <div>
              <input type="submit" value="SUBMIT" name="submit" id="submit" className="submit"/>
            </div></div>
          </div>
        </div>
      </form>
    </div>
  );
}
export default Simpleform;
